import { Ref } from 'vue'

import { createProvideInject } from '@collector/shared-ui'

export const [provideRequestUrl, injectRequestUrl] =
  createProvideInject<Ref<string | undefined>>('requestUrl')
